<div class="p-6 card-style-full">
  <div class="flex justify-between items-center mb-4">
    <h2 class="text-gray-700 font-bold">
      Atribuir Veículo @if (data.nomeFornecedor) {<span class="text-gray-400 font-normal"> — {{ data.nomeFornecedor }}</span>}
    </h2>
    <button class="btn-icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-tab-group>
    <mat-tab label="Veículos do fornecedor">
      <div class="pt-4">
        @if (loadingList) {
          <mat-spinner diameter="28" class="loading-spinner"></mat-spinner>
        } @else if (vehicles.length == 0) {
          <p class="text-sm text-gray-500">Este fornecedor ainda não tem veículos cadastrados.</p>
        } @else {
          <div class="flex flex-col gap-2 max-h-80 overflow-auto">
            @for (vehicle of vehicles; track vehicle.id) {
              <div class="flex justify-between items-center border rounded px-3 py-2">
                <div>
                  <div class="font-bold">{{ vehicle.placa }} — {{ vehicle.modelo }} @if (vehicle.ano) {<span class="text-gray-400">({{ vehicle.ano }})</span>}</div>
                  <div class="text-sm text-gray-500">Cor: {{ vehicle.cor || '-' }}</div>
                  <div class="flex flex-wrap gap-1 mt-1">
                    @if (vehicle.seguroVencido) {
                      <span class="chip chip-warning">Seguro vencido</span>
                    } @else if (vehicle.seguroProximoDoVencimento) {
                      <span class="chip chip-warning">Seguro vence em {{ vehicle.diasParaVencimentoSeguro }} dias</span>
                    }
                  </div>
                </div>
                <button
                  mat-flat-button class="btn-tg-white"
                  [disabled]="assigningId == vehicle.id"
                  (click)="assignExisting(vehicle.id)"
                >
                  @if (assigningId == vehicle.id) {
                    <mat-spinner diameter="18" class="loading-spinner"></mat-spinner>
                  } @else {
                    Selecionar
                  }
                </button>
              </div>
            }
          </div>
        }
      </div>
    </mat-tab>

    <mat-tab label="Cadastrar novo">
      <div [formGroup]="form" class="pt-4 flex flex-col gap-3">
        <div class="flex gap-4">
          <mat-form-field class="input-tg" style="width:160px" appearance="outline">
            <mat-label>Placa *</mat-label>
            <input matInput formControlName="placa" [mask]="'AAAAAAA'" />
          </mat-form-field>
          <mat-form-field class="input-tg" style="width:160px" appearance="outline">
            <mat-label>Marca *</mat-label>
            <mat-select [formControl]="marcaControl">
              @for (item of vehicleBrands; track item.id) {
                <mat-option [value]="item.id">{{ item.marca }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field class="input-tg flex-1" appearance="outline">
            <mat-label>Modelo *</mat-label>
            <mat-select formControlName="veiculoModeloId" [disabled]="!marcaControl.value">
              @for (item of filteredVehicleModels; track item.id) {
                <mat-option [value]="item.id">{{ item.modelo }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field class="input-tg flex-1" appearance="outline">
            <mat-label>Tipo de Veículo *</mat-label>
            <mat-select formControlName="tipoVeiculoId">
              @for (item of vehicleTypes; track item.id) {
                <mat-option [value]="item.id">{{ item.descricao }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field class="input-tg" style="width:140px" appearance="outline">
            <mat-label>Cor *</mat-label>
            <input matInput formControlName="cor" />
          </mat-form-field>
          <mat-form-field class="input-tg" style="width:110px" appearance="outline">
            <mat-label>Ano</mat-label>
            <input matInput type="number" formControlName="ano" />
          </mat-form-field>
        </div>
        <div class="flex gap-4">
          <mat-form-field class="input-tg flex-1" appearance="outline">
            <mat-label>CRLV</mat-label>
            <input matInput formControlName="crlv" />
          </mat-form-field>
          <mat-form-field class="input-tg flex-1" appearance="outline">
            <mat-label>Seguro</mat-label>
            <input matInput formControlName="seguro" />
          </mat-form-field>
          <mat-form-field class="input-tg" style="width:160px" appearance="outline">
            <mat-label>Validade seguro</mat-label>
            <input matInput [matDatepicker]="seguroPicker" (focus)="seguroPicker.open()" formControlName="seguroValidade" />
            <mat-datepicker-toggle matIconSuffix [for]="seguroPicker"></mat-datepicker-toggle>
            <mat-datepicker #seguroPicker></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="flex justify-end mt-2">
          <button
            mat-flat-button class="btn-tg"
            [disabled]="form.invalid || creating"
            (click)="createAndAssign()"
          >
            @if (creating) {
              <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
            } @else {
              Cadastrar e atribuir
            }
          </button>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
